
import { defineComponent, ref } from 'vue';
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    setup() {
        const { t } = useI18n();
        const drawerOption = ref(false);
        const loader = ref(false);
        const listAfiliations = ref<Array<any>>([]);

        const openDrawer = () => {
            drawerOption.value = true;
        }
        
        return {
            t,
            loader,
            drawerOption,
            listAfiliations,
            //events
            openDrawer
        }
    },
})
